import { gql } from 'graphql-tag';
import type { TypedDocumentNode } from '@apollo/client';
import type { IGetAssessmentTimingsData, IGetAssessmentTimingsVars } from '../types';

export const GET_ASSESSMENT_TIMINGS: TypedDocumentNode<IGetAssessmentTimingsData, IGetAssessmentTimingsVars> = gql`
  query getAssessmentTimings($input: ReadAssessmentTimingsInput!) {
    readAssessmentTimings(input: $input) {
      assessmentTitle
      sectionTimings {
        sectionTitle
        standardDuration
      }
      created
      updated
    }
  }
`;
